export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export async function withRetry<T>(
    fn: () => Promise<T>,
    maxRetries = 3,
    baseDelayMs = 2000
): Promise<T> {
    let lastError: any;

    for (let i = 0; i < maxRetries; i++) {
        try {
            if (!window.navigator.onLine) {
                // if user loses connection momentarily, wait before attempting
                await sleep(2000);
            }
            return await fn();
        } catch (err: any) {
            lastError = err;
            // If MSAL says interaction is required, don't retry silently
            if (err && err.name === 'InteractionRequiredAuthError') {
                throw err;
            }

            console.warn(`[NetworkRetry] Attempt ${i + 1} of ${maxRetries} failed. Retrying in ${baseDelayMs * (i + 1)}ms...`, err);
            // Wait before retrying
            await sleep(baseDelayMs * (i + 1));
        }
    }

    throw lastError;
}
